import styled, { css } from 'styled-components';

export const NoMarginBottom = styled.div<{ $isOther: boolean }>`
  ${({ $isOther }) =>
    $isOther &&
    css`
      .ant-form-item {
        margin-bottom: 0;
      }
    `}
`;
